const state = {
  notificationItems: [],
  notificationType: 'is-info'
}

const mutations = {
  LOAD_NOTIFICATION_ITEMS (state, payload) {
    state.notificationItems = payload
  }
}

const actions = {
  loadNotificationItems ({ commit }, notificationItems) {
    commit('LOAD_NOTIFICATION_ITEMS', notificationItems)
  }
}

const getters = {
  showNotification: state => {
    if (state.notificationItems.length === 0) {
      return false
    } else {
      return true
    }
  },

  notificationItemsList: state => {
    return state.notificationItems
  },

  notificationType: state => {
    return state.notificationType
  }
}

const notificationModule = {
  state,
  mutations,
  actions,
  getters
}

export default notificationModule
